export const domain = 'https://api.centz.vn';

